import { render, staticRenderFns } from "./member_mobile.vue?vue&type=template&id=384d63ac&scoped=true"
import script from "./member_mobile.vue?vue&type=script&lang=js"
export * from "./member_mobile.vue?vue&type=script&lang=js"
import style0 from "./member_mobile.vue?vue&type=style&index=0&id=384d63ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d63ac",
  null
  
)

export default component.exports